var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPodiumNew = function SvgPodiumNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 188,
    viewBox: "0 0 813 188",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M812.003 65.1019H588.591L552.003 46.9824L752.868 46.9824L812.003 65.1019Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M812 64.998H588.47L541 169.998H732.999L812 64.998Z",
    fill: "url(#paint1_linear_1_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552.126 50.998L489 166.998H552.126L588.5 64.998L552.126 50.998Z",
    fill: "url(#paint2_linear_1_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 166.697L236.5 166.696L200.539 60.1127L0.404241 60.1127L76.9998 166.697Z",
    fill: "url(#paint3_linear_1_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 60.0617L200.261 60.0617L267.001 38.3184L53.6354 38.3184L0.000488281 60.0617Z",
    fill: "url(#paint4_linear_1_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.228 43.998L300 172.998H237.316L201 60.6593L267.228 43.998Z",
    fill: "url(#paint5_linear_1_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M565.002 28.9912H239.002L280.637 0H523.366L565.002 28.9912Z",
    fill: "url(#paint6_linear_1_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M565 29H239L293.499 188H506.499L565 29Z",
    fill: "url(#paint7_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 764204,
    y1: 38568.8,
    x2: 764199,
    y2: 44940.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 601.295,
    y1: 63.9598,
    x2: 601.012,
    y2: 147.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 137470,
    y1: 143253,
    x2: 104927,
    y2: 106876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 149,
    y1: 152.622,
    x2: 145.973,
    y2: 47.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F338C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 692161,
    y1: 46701.7,
    x2: 692154,
    y2: 54419.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 100085,
    y1: 150318,
    x2: 66791.7,
    y2: 124462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 820928,
    y1: 61634.9,
    x2: 820917,
    y2: 71829.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 332.938,
    y1: 27.5085,
    x2: 323.356,
    y2: 163.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPodiumNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/podium-new.6d0b57f5.svg";
export { ForwardRef as ReactComponent };